<template>
  <div id="app">
    <div class="preloader">
      <div class="lds-ripple">
        <div class="lds-pos"></div>
        <div class="lds-pos"></div>
      </div>
    </div>
    <div
      id="main-wrapper"
      data-theme="light"
      data-layout="vertical"
      data-navbarbg="skin6"
      data-sidebartype="full"
      data-sidebar-position="fixed"
      data-header-position="fixed"
      data-boxed-layout="full"
    >
      <HeaderView />
      <SidebarView />
      <main class="page-wrapper">
        <BreadcrumbView />
        <router-view></router-view>
        <FooterView />
      </main>
    </div>
  </div>
</template>

<script>
import HeaderView from './components/Header'
import SidebarView from './components/Sidebar'
import BreadcrumbView from './components/Breadcrumb'
import FooterView from './components/Footer'

export default {
  components: {
    HeaderView,
    SidebarView,
    FooterView,
    BreadcrumbView
  },
  name: 'app'
}
</script>



// WEBPACK FOOTER //
// src/App.vue